@if (!(isInitalCommunicationLoading$ | async)) {

<div class="root" skyTranslationGuard="skypro-communication">
  @if ((threadCount$ | async) === 0) {
  <div class="empty-message" [class.-compact]="hasCompactEmptyView" data-test="пустой список обсуждений">
    @if (!(isLoading$ | async) && !hasCompactEmptyView) {

    <img class="empty-message-image" [src]="empty" />
    <span class="empty-message-content" [innerHtml]="'skyproCommunications.empty' | transloco"></span>

    }
  </div>
  }

  <div class="threads" #threadsContainer>
    @if (showCreateThreadForm && !readOnly) {
    <div class="create-new-thread-form" [class.-form-visible]="isCreateNewThreadFormVisible$ | async">
      <div class="ask-question-trigger" (click)="showCreateNewThreadForm()" data-test="задать вопрос">
        <vim-core-user-avatar
          [user]="currentUser$ | async"
          [avatarUrl]="currentUserAvatarUrl$ | async"
          [size]="40"
        ></vim-core-user-avatar>
        <div class="ask-question-trigger-text">{{ 'skyproCommunications.ask' | transloco }}</div>
      </div>
      @if (isCreateNewThreadFormVisible$ | async) {
      <skypro-communication-form
        [hasAutofocus]="true"
        [allowedAttachmentTypes]="allowedAttachmentTypes"
        (createdThread)="hideCreateNewThreadForm()"
      ></skypro-communication-form>
      }
    </div>
    } @for (thread of (threads$ | async); track identify($index, thread)) {
    <div class="thread">
      <!-- начальное сообщение треда не в режиме редактирования -->
      @if ((editingMessageId$ | async) !== thread.id) {
      <skypro-communication-thread
        [thread]="thread"
        [isHighlighted]="(highlightedThreadId$ | async) === thread.id"
        [isExpandedMessages]="(expandedThreadIds$ | async)?.includes(thread.id)"
        [canEdit]="thread.author.user.id === currentUserId"
        [canDelete]="canDeleteAnyMessage || thread.author.user.id === currentUserId"
        [canClose]="!(isLoading$ | async) && canClose"
        [canPin]="!(isLoading$ | async) && canPin"
        [canHide]="!(isLoading$ | async) && canHide"
        [readOnly]="readOnly"
        [hasActions]="hasActions"
        (delete)="deleteThread(thread.id)"
        (edit)="startEditing(thread.id)"
        (selectedThreadIdChange)="addExpandedThreadId(thread.id)"
        (unselectedThreadIdChange)="removeExpandedThreadId(thread.id)"
        (replyClicked)="setReplyingThreadId(thread.id)"
        (close)="emitCloseThread(thread.id)"
        (pin)="emitPinThread(thread.id)"
        (unpin)="emitUnpinThread(thread.id)"
        (hide)="emitHideThread(thread.id)"
        (show)="emitShowThread(thread.id)"
      >
        <skypro-communication-like
          [likeCount]="thread.likeCount"
          [isLikePressed]="thread.isLikePressed"
          [isDislikePressed]="thread.isDislikePressed"
          [isDislikeEnabled]="thread.author.hasTutorIcon ?? false"
          (like)="like($event, thread.contentId)"
          (dislike)="openReportDialog(thread)"
        ></skypro-communication-like>
      </skypro-communication-thread>
      }

      <!-- начальное сообщение треда в режиме редактирования -->
      @if ((editingMessageId$ | async) === thread.id) {
      <div class="edit-form">
        <skypro-communication-form
          [editMessageContent]="thread"
          (finishEditing)="finishEditing()"
          data-test="форма редактирования"
        ></skypro-communication-form>
      </div>
      }

      <!-- развернутые ответы на тред -->
      @if ((expandedThreadIds$ | async)?.includes(thread.id)) {
      <div class="message-container">
        @for (message of thread.messages; track identify($index, message)) { @if ((editingMessageId$ | async) !==
        message.id) { @switch (message.type) { @case (MessageType.text) {
        <skypro-communication-message
          [message]="message"
          [isDeleted]="message.isDeleted"
          [canEdit]="message.author.user.id === currentUserId"
          [canDelete]="canDeleteAnyMessage || message.author.user.id === currentUserId"
          [isCompactPreview]="!((highlightedThreadId$ | async) === thread.id)"
          [hasActions]="hasActions"
          (delete)="deleteMessage(message.id)"
          (edit)="startEditing(message.id)"
        >
          <ng-template skyproCommunicationLike>
            <skypro-communication-like
              [likeCount]="message.likeCount"
              [isLikePressed]="message.isLikePressed"
              [isDislikePressed]="message.isDislikePressed"
              [isDislikeEnabled]="message.author.hasTutorIcon ?? false"
              (like)="like($event, message.contentId)"
              (dislike)="openReportDialog(message)"
            ></skypro-communication-like>
          </ng-template>
        </skypro-communication-message>
        } } } @if ((editingMessageId$ | async) === message.id) {
        <div class="edit-form -in-thread">
          <skypro-communication-form
            [thread]="thread"
            [editMessageContent]="message"
            (finishEditing)="finishEditing()"
            data-test="форма редактирования"
          ></skypro-communication-form>
        </div>
        } }
      </div>
      }

      <!-- форма ответа на тред -->
      @if (!readOnly && (replyingThreadId$ | async) === thread.id) {
      <skypro-communication-form
        class="reply-in-thread-form"
        [thread]="thread"
        [allowedAttachmentTypes]="allowedAttachmentTypes"
        (createdReplyInThread)="updateExpandedThread(thread.id)"
        [hasCallTutorButton]="checkIfHasCallTutorButton(thread.messages)"
        [canAskTutorOrAI]="canAskTutorOrAI"
      ></skypro-communication-form>
      }
    </div>
    }
  </div>

  @if (showOnlyHighlighted$ | async) { @if (threadCount$ | async; as threadCount) { @if (threadCount > 1) {
  <div class="show-all-button-container">
    <div>
      {{ 'skyproCommunications.onlyHighlightedDescription' | transloco : { threadCount: threadCount - 1 } |
      skyUiTypograf }}
    </div>
    <br />
    <ds-button (click)="showAllMessages()" type="secondary" size="s">
      {{ 'skyproCommunications.onlyHighlightedButton' | transloco }}
    </ds-button>
  </div>
  } } }
</div>

}
<!--
  Лоадер будет отображаться и при отправке сообщения, из-за общего флага для загрузки всего.
  Оставил так, потому что 1. выглядит более менее 2. пользователь это увидит только если в обсуждениях пусто 3. не хочу усложнять логику
-->
@if (hasLoader && (isLoading$ | async)) {
<div class="loader">{{ 'skyproCommunications.loadingThreads' | transloco }}</div>
}
